import { HttpEvent, HttpHandler, HttpRequest, HttpInterceptor as NgHttpInterceptor } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
/**
 * Adds authorization token to every request made with httpClient
 */
export class AuthInterceptor implements NgHttpInterceptor {
  private authService = inject(AuthService);

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.authToken) {
      const headers = {
        "X-Auth-Token": this.authService.authToken,
      };
      const modifiedHttpRequest: any = httpRequest.clone({
        setHeaders: headers,
      });
      return next.handle(modifiedHttpRequest);
    }
    return next.handle(httpRequest);
  }
}
